import PropTypes from 'prop-types';
import React, { Component } from 'react';

import { translate } from 'services/i18nService';
import EpayService from 'services/EpayService/EpayService';
import UserStore from 'stores/UserStore';
import RegistrationForm from 'pages/User/RegistrationForm/RegistrationForm';
import Modal from 'components/Modal/Modal';
import VerifyEmailSent from 'components/VerifyEmailSent/VerifyEmailSent';
import { SIGN_UP_TYPE } from 'enum/helpers';
import { EPAY_PRODUCT_TYPES } from 'enum/payments';

import styles from './RegistrationGoldModal.css';


class RegistrationGoldModal extends Component {
  static propTypes = {
    setIsAnyModalShown: PropTypes.func,
    showClose: PropTypes.bool,
    showRegistrationGoldModal: PropTypes.bool,
    onClose: PropTypes.func,
  };

  static defaultProps = {
    setIsAnyModalShown: undefined,
    showClose: true,
    showRegistrationGoldModal: undefined,
    onClose: () => undefined,
  };

  state = {
    elementClickedId: '',
    products: [],
    secondStepVisible: false,
  };

  componentDidMount() {
    EpayService.getProductsForGoldenRegistration()
      .then((res) => this.setState({ products: res.data.products }));
  }

  sendIdToForm = (e) => this.setState({ elementClickedId: e.target.id });

  setStepVisibility = () => {
    this.setState({ secondStepVisible: true });
  };

  closeModal = () => {
    const { onClose } = this.props;
    const { handleResendEmailResponse } = UserStore;
    handleResendEmailResponse(false);
    this.setState({ secondStepVisible: false });
    onClose();
  };

  render() {
    const { showRegistrationGoldModal, showClose } = this.props;
    const { products, secondStepVisible } = this.state;
    const membership = products.find((x) => x.type === EPAY_PRODUCT_TYPES.MEMBERSHIP);

    return (
      <Modal
        close={this.closeModal}
        show={showRegistrationGoldModal}
        showClose={showClose}
        size="large"
        type="full"
      >
        {secondStepVisible ? (
          <VerifyEmailSent setIsAnyModalShown={this.props.setIsAnyModalShown} onClickClose={this.closeModal} />
        ) : (
          <div className={styles.container} onClick={this.sendIdToForm}>
            <div className={styles.leftColumn} />
            <div className={styles.rightColumn}>
              <div className={styles.content}>
                <div className={styles.titleWrapper}>
                  <h3>{translate('gold.v2.create.gold.account')}</h3>
                  <span>
                    {translate('gold.v2.create.gold.account.title', {
                      0: products.length && membership.amount,
                      1: products.length && membership.details.bonus,
                    })}
                  </span>
                </div>
                <div className={styles.regFromWrapper}>
                  <RegistrationForm
                    changeRegisterStep={this.setStepVisibility}
                    closeGoldRegistrationModal={this.closeModal}
                    elementClickedId={this.state.elementClickedId}
                    membership={membership}
                    signUpType={SIGN_UP_TYPE.GOLD}
                  />
                </div>
                <div className={styles.footer}>
                  <span>
                    * {translate('gold.v2.gold.you.will.receive', { 0: products.length && membership.details.bonus })}
                  </span>
                </div>
              </div>
            </div>
          </div>
        )}
      </Modal>
    );
  }
}

export default RegistrationGoldModal;
